import React from "react";
import { useSelector } from "react-redux";
import SupportTicketId from "../components/supportTicket/supportTicketId/supportTicketId";
import Breadcrumb from "../components/breadcrumb/breadcrumb";
import withTracker from "./withtracker";
import AuthorizationHOC from "./AuthorizationHOC";
import { REGISTERED_USERS } from "../constants/userGroups";
import withBreadCrumb from "./withBreadcrumb";
import useQueryParams from "../customHooks/useQueryParams";
import PopupMessage from "../components/popupMessage/popupMessage";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  createTicket,
  fetchTicketById,
  updateTicketById,
  fetchTicketStates,
  createTicketMessage,
} from "../Apis/ticket";
import FaSpinner from "../components/faSpinner/faSpinner";

const TicketCreatedMessage = () => {
  return (
    <PopupMessage
      showCloseButton={true}
      transitionInSeconds={0.8}
      inFromDirection={"bottom"}
      initialPosition={{
        x: "center",
        y: "bottom",
      }}
    >
      <div style={{ fontSize: "1.3em", margin: 10, textAlign: "center" }}>
        Your ticket is successfully raised we will get back to you as soon as
        possible.
      </div>
    </PopupMessage>
  );
};

function SupportTicketIdHOC(props) {
  let query = useQueryParams();

  const { breadcrumb, match } = props;
  const { ticketId } = match.params;
  const csrfToken = useSelector(
    ({ applicationUser }) => applicationUser?.token
  );
  const userId = useSelector((state) => state.applicationUser?.uid);

  const username = useSelector(({ applicationUser }) => applicationUser?.name);
  const userUuid = useSelector(({ applicationUser }) => applicationUser?.uuid);

  const { data, isLoading, refetch } = useQuery(
    [`ticket-${ticketId}`, { userId }],
    () => fetchTicketById(csrfToken, ticketId, userId)
  );

  const { data: states } = useQuery(["ticket-states", { userId }], () =>
    fetchTicketStates(csrfToken, userId)
  );

  const update = useMutation(
    (ticketData) => updateTicketById(csrfToken, userId, ticketData),
    {
      onSuccess: () => refetch(),
    }
  );

  const save = useMutation(
    (messageData) => createTicketMessage(csrfToken, userId, messageData),
    {
      onSuccess: () => refetch(),
    }
  );

  const saveTicketId = (payload) => {
    save.mutate({
      supportTicketId: data?.id,
      body: payload.body,
      attachmentId: payload.files?.[0]?.uuid || null,
    });
  };

  const changeTicketIdStatus = (statusName) => {
    // Find the state ID that matches the status name
    const targetState = states?.find((s) => s.name === statusName);

    if (!targetState) {
      console.error(`State "${statusName}" not found`);
      return;
    }

    update.mutate({
      id: data.id,
      supportTicketStateId: targetState.id,
    });
  };

  if (isLoading) {
    return <FaSpinner loading={isLoading} />;
  }

  if (!data) {
    return <div>Ticket not found</div>;
  }

  return (
    <div>
      <Breadcrumb
        {...breadcrumb}
        params={{
          ticket: { name: data.title },
        }}
      />

      {query.get("created") && <TicketCreatedMessage />}
      <SupportTicketId
        ticket={data}
        loading={isLoading || save.isLoading}
        saveTicketId={saveTicketId}
        statusUpdating={update.isLoading}
        changeTicketIdStatus={changeTicketIdStatus}
        username={username}
        userId={userId}
        userUuid={userUuid}
      />
    </div>
  );
}

export default withTracker(
  AuthorizationHOC(REGISTERED_USERS)(
    withBreadCrumb(SupportTicketIdHOC, {
      name: "{ticket}",
      parents: ["Support", "Tickets"],
    })
  )
);
